<div id="goliza-welcome" class="w-100-p h-100-p" fxLayout="column" fxLayoutAlign="space-between center" fusePerfectScrollbar>
    <div fxLayout="row" class="w-100-p" ngClass.xs="w-320" fxLayoutAlign="space-between start">
        <div fxLayout="column" class="w-100-p text-center" > 
            <!-- <div class="text-center mt-20" ngClass.gt-xs="">
                <img class="goliza-logo" src="assets/images/backgrounds/main-logo.png">
            </div> -->
            <!-- <div *ngIf="!isWaitingBusiness else selectBusiness" class="mt-10 " id="contForm" fxLayout="column"
                fxLayoutAlign="start center">
                <mat-form-field appearance="outline" ngClass.gt-xs="w-400">
                    <mat-label>Folio ticket</mat-label>
                    <input matInput placeholder="001122334455" maxlength="128" [formControl]="folioControl" type="text"
                        (keyup.enter)="find()">
                    <mat-icon matSuffix>local_offer</mat-icon>
                    <mat-error *ngIf="folioControl.hasError('required')">Folio ticket requerido</mat-error>
                </mat-form-field>
                <div class="text-center mb-24">
                    <button mat-button class="fuse-white-bg" (click)="find()">
                        Buscar
                    </button>
                </div>
            </div> -->
        </div>
    </div>
 
</div>
<ng-template #selectBusiness>
    <div class="mt-80 " fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="24px ">
        <p class="h1 fuse-white-fg">
            Tu ticket pertenece a</p>
        <button mat-button class="fuse-white-bg w-160" (click)="launch('P')">
            PANADERIA 🥐
        </button>
        <button mat-button class="fuse-white-bg  w-160" (click)="launch('R')">
            ROSTICERIA 🍗
        </button>
    </div>
</ng-template>